import Highcharts from 'highcharts';

export function buildSparklineOptions(seriesData, categories, { yMin, yMax, plotLines, color, tooltipSuffix, logarithmic, t, rawData, onPointClick }) {
    return {
        chart: { type: 'spline', height: 150, spacing: [6, 6, 3, 6], backgroundColor: 'transparent' },
        title: { text: null },
        xAxis: {
            categories,
            labels: {
                enabled: true,
                style: { fontSize: '10px', color: '#999' },
                rotation: -45,
            },
            lineWidth: 1,
            lineColor: '#ddd',
            tickWidth: 0,
        },
        yAxis: {
            title: { text: null },
            labels: { enabled: true, style: { fontSize: '10px', color: '#999' } },
            type: logarithmic ? 'logarithmic' : 'linear',
            min: yMin,
            max: yMax,
            gridLineWidth: 1,
            gridLineColor: '#f0f0f0',
            plotLines: plotLines || [],
        },
        legend: { enabled: false },
        credits: { enabled: false },
        tooltip: {
            useHTML: true,
            formatter: function () {
                const idx = this.point.index;
                const point = rawData && rawData[idx];
                let html = `<span style="font-size:10px">${this.key}</span><br/>`
                    + `<b>${Highcharts.numberFormat(this.y, 2)}</b> ${tooltipSuffix || ''}`;
                if (point && point.nodo) {
                    html += `<br/><span style="font-size:10px;color:#666">${t('cqp.audio.node')}: <b>${point.nodo}</b></span>`;
                }
                return html;
            },
        },
        plotOptions: {
            spline: {
                lineWidth: 2,
                cursor: 'pointer',
                marker: {
                    enabled: true,
                    radius: 3,
                    symbol: 'circle',
                    fillColor: color,
                    lineWidth: 1,
                    lineColor: '#fff',
                    states: { hover: { enabled: true, radius: 5, lineWidth: 2, lineColor: '#fff' } },
                },
                states: { hover: { lineWidth: 3 } },
                point: {
                    events: {
                        click: function () {
                            const idx = this.index;
                            if (onPointClick && rawData && rawData[idx]) {
                                onPointClick(rawData[idx]);
                            }
                        },
                    },
                },
            },
        },
        series: [{
            data: seriesData,
            color: color,
        }],
    };
}
